import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { AppContext } from '../../../AppModulesWrapper';
import { selectIsSubagentNotEnoughMoney } from '../../selectors/publishInfo';
import { selectIsMobileLayout } from '../../selectors/layout';
import { selectIsSaveDraftButtonAvailable } from '../../selectors/checkoutInfo';
import { setPlacingMoneySource } from '../../actions/publishTerms';
import { EMoneySource } from '../../types/reducers/user';
import { setIsSubagentNotEnoughMoney } from '../../actions/publishInfo';
import { saveDraftStart } from '../../actions/draft';
import { saveOfferDraft } from '../../actions/webview';
import { loadPublishTerms } from '../../thunks/publishTerms/loadPublishTerms';

import { SubagentNotEnoughMoneyModal } from './SubagentNotEnoughMoneyModal';

export const SubagentNotEnoughMoneyModalContainer = () => {
  const dispatch = useDispatch();

  const isMobile = useSelector(selectIsMobileLayout);
  const isSubagentNotEnoughMoney = useSelector(selectIsSubagentNotEnoughMoney);
  const withSaveDraft = useSelector(selectIsSaveDraftButtonAvailable);

  const { webview } = React.useContext(AppContext);

  const closeModal = React.useCallback(() => {
    dispatch(setIsSubagentNotEnoughMoney(false));
  }, [dispatch]);

  const setSelfMoneySource = React.useCallback(() => {
    dispatch(setPlacingMoneySource(EMoneySource.Self));
    dispatch(loadPublishTerms());
    closeModal();
  }, [dispatch, closeModal]);

  const saveDraftHandler = React.useCallback(() => {
    dispatch(saveDraftStart());

    webview.sendAction(saveOfferDraft());
    closeModal();
  }, [dispatch, webview, closeModal]);

  return (
    <SubagentNotEnoughMoneyModal
      isOpen={isSubagentNotEnoughMoney}
      isMobile={isMobile}
      withSaveDraft={withSaveDraft}
      onClose={closeModal}
      onChangeMoneySource={setSelfMoneySource}
      onSaveDraft={saveDraftHandler}
    />
  );
};
